interface AuthFooterProps {
  heading: string;
  description: string;
}

export const AuthFooter = ({ heading, description }: AuthFooterProps) => {
  return (
    <div className="flex flex-col gap-3 items-center text-center">
      <h1 className="font-semibold text-xl md:text-2xl text-primary max-w-md">
        {heading}
      </h1>
      <p className="text-base max-w-lg">{description}</p>
    </div>
  );
};
